// import React, { useState, useEffect } from "react";
// import { useLocation} from 'react-router-dom';
// import Logo from '../../../assets/img/png/resto.png';
// import { User } from "../../../api/user";
// import ResetPasswordForm from '../../../components/Admin/ResetPasswordForm';
//import Error404 from '../../Error404';


import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Header, Segment, Form, Button, Image, Message } from "semantic-ui-react";
//import Logo from '../../../assets/img/png/resto.png';

//import userController from "../controllers/userController";

import './Reset.scss';
import { User } from "../../../api";
import { ResetPasswordForm } from "../../../components/Admin/Auth";

const userController = new User();


export default function Reset() {
  const [userByToken, setUserByToken] = useState(null);
  const [isValid, setIsValid] = useState(false);

  const urlparams = useLocation().pathname.split("/").filter((item) => item);

  useEffect(() => {
    if (!isValid) {
      userController.getUserByResetTokenApi(urlparams[1]).then((response) => {
        setUserByToken(response.email ? response : null);
      });
      setIsValid(true);
    }
  }, []);

  if (!userByToken) {
    return (
      <Container textAlign="center" style={{ marginTop: "5em" }}>
        <Segment placeholder>
          <Header as="h3" color="red">
            El tiempo de restablecimiento de contraseña ha caducado o el token es inválido
          </Header>
        </Segment>
      </Container>
    );
  }

  return (
    <Container textAlign="center" style={{ marginTop: "3em" }}>
      <Segment stacked>
        <Header as="h2" textAlign="center">
          Restablezca su contraseña
        </Header>

        <ResetPasswordForm userByToken={userByToken} />

        <Message info>
          Si no quiere restablecer la contraseña cierre esta pestaña
        </Message>
      </Segment>
    </Container>
  );
}

